module.exports = __webpack_public_path__ + "img/germany-infectious-diseases-male.0e732a15.png";